<template>
    <div
        class="question"
        :id="`question-${question.id}`">
        <div class="title">
            {{ question.question }}
        </div>

        <div class="context-nav context-sub-assignment-page-nav">
            <b-dropdown
                class="ellipsis-nav sub-assignment-page-nav"
                no-caret
                variant="primary"
                right
                toggle-class="sub-assignment-page-context-menu">
                <template v-slot:button-content>
                    <i class="fas fa-ellipsis-v"></i>
                </template>

                <b-dropdown-item
                    class="edit-sub-assignment-page"
                    v-b-modal="'questionnaire-question-edit-modal' + question.id">
                    <i class="btn-edit"></i>{{ $t('questionnaire.edit_question') }}
                </b-dropdown-item>

                <b-dropdown-item
                    class="remove-sub-assignment-page"
                    @click.prevent.stop="deleteQuestion(question)">
                    <i class="btn-remove"></i>{{ $t('questionnaire.delete_question') }}
                </b-dropdown-item>
            </b-dropdown>

            <design-2021-questionnaire-edit-question-modal-component
                :question-in="question"></design-2021-questionnaire-edit-question-modal-component>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'design-2021-questionnaire-edit-question-component',
    props: ['question', 'section'],
    components: {
        draggable,
    },
    methods: {
        deleteQuestion(question) {
            this.alert.saving();
            this.axios.delete(this.routes.questionnaireQuestionDelete(question.id)).then(
                (response) => {
                    question.remove();

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.hidden-anchor {
    position: relative;
    top: -110px;
    visibility: hidden;
}

.question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: map-get($grid-gutter-spacing, 'eight');
    padding-bottom: map-get($grid-gutter-spacing, 'eight');

    .title {
        width: calc(100% - 37px);
    }

    .context-sub-assignment-page-nav {
        align-self: flex-start;
    }

    &:not(:nth-last-child(2)) {
        border-bottom: 3px dotted $border-color;
    }
}

.context-sub-assignment-page-nav ::v-deep {
    .sub-assignment-page-nav {
        .sub-assignment-page-context-menu {
            line-height: 1;
        }

        .dropdown-menu {
            border: 1px solid $border-color;
        }

        .edit-sub-assignment-page {
            i {
                color: $primary;
            }
        }

        .remove-sub-assignment-page {
            i {
                color: $danger;
            }
        }

        .remove-sub-assignment-page,
        .edit-sub-assignment-page {
            font-size: $default-font-size;

            .dropdown-item {
                display: flex;
                align-items: center;

                i {
                    margin-right: map-get($grid-gutter-spacing, 'eight');
                    font-size: $base-font-size;
                    width: 20px;
                }
            }
        }
    }
}
</style>
